import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function OfflineManagerPin() {
  const navigate = useNavigate();
  const {
    state: { fob },
  } = useLocation();
  const [pin, setPinState] = useState('');

  const addToPin = useCallback(
    (k: string) => {
      setPinState(`${pin}${k}`);
    },
    [setPinState, pin],
  );

  useEffect(() => {
    const eventHandler = (e: KeyboardEvent) => {
      const regex = /^[0-9]$/gm;
      if (regex.exec(e.key) !== null) addToPin(e.key);
    };
    window.addEventListener('keydown', eventHandler);
    return () => window.removeEventListener('keydown', eventHandler);
  }, [addToPin]);

  return (
    <div className="pos-modal-portal">
      <div
        className="pos-modal-overlay"
        onClick={(e) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if ((e.target as any).className === 'pos-modal-overlay') navigate('/');
        }}
      >
        <div className="pos-modal pos-modal_role_sign-in">
          <div className="pos-modal__content">
            <div className="pos-sign-in js-sign-in">
              <div className="pos-sign-in__header">
                <h2 className="pos-sign-in__title">Manager Fob</h2>
                <p className="pos-sign-in__subtitle">Please enter the pin code to enable the fob:</p>
                <p className="pos-sign-in__subtitle">{fob}</p>
              </div>
              <div className="pos-sign-in__info"></div>
              <div className="pos-sign-in__controls">
                <div className="pos-sign-in__pin">
                  <div className="pos-field pos-field_role_pin">
                    <div className="pos-field__group">
                      <div className="pos-field__box">{'*'.repeat(pin.length)}</div>
                      <button
                        className="pos-field__action"
                        onClick={() =>
                          navigate('/offline-manager-complete', {
                            state: { fob, pin },
                          })
                        }
                        disabled={pin.length < 6}
                      >
                        Enter
                      </button>
                    </div>
                  </div>
                </div>
                <div className="pos-sign-in__numpad">
                  <div className="pos-numpad pos-numpad_role_sign-in">
                    <div className="pos-numpad__controls">
                      <div className="pos-numpad__controls-row">
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('1')}>
                          1
                        </button>
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('2')}>
                          2
                        </button>
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('3')}>
                          3
                        </button>
                      </div>
                      <div className="pos-numpad__controls-row">
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('4')}>
                          4
                        </button>
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('5')}>
                          5
                        </button>
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('6')}>
                          6
                        </button>
                      </div>
                      <div className="pos-numpad__controls-row">
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('7')}>
                          7
                        </button>
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('8')}>
                          8
                        </button>
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('9')}>
                          9
                        </button>
                      </div>
                      <div className="pos-numpad__controls-row">
                        <button className="pos-numpad__control" type="button" onClick={() => addToPin('0')}>
                          0
                        </button>
                        <button
                          className="pos-numpad__control pos-numpad__control_role_clear"
                          type="button"
                          onClick={() => setPinState('')}
                        >
                          CLR
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfflineManagerPin;
